<template>
  <div class="home content-continer" :style="{minHeight:minheight + 'px'}">
    <!-- 最上面项目详情 -->
    <div class="base-content items">
      <div style="margin-bottom:30px;">
        <a class="list-name">{{evaluatelist.projectName}}</a>
      </div>
      <ul class="list-msg">
        <li>
          <p>CRC人数</p>
          <p>{{evaluatelist.crcNum?evaluatelist.crcNum:'无'}}</p>
        </li>
        <li>
          <p>专业名称</p>
          <p>{{evaluatelist.specialityName?evaluatelist.specialityName:'无'}}</p>
        </li>
        <li v-if="evaluatelist.managerName">
          <p>负责人</p>
          <p>{{evaluatelist.managerName?evaluatelist.managerName:'无'}}</p>
        </li>
        <li>
          <p>项目类型</p>
          <p>{{evaluatelist.phaseDesc?evaluatelist.phaseDesc:'无'}}</p>
        </li>
        <li>
          <p>项目开始时间</p>
          <p>{{evaluatelist.startDate?evaluatelist.startDate:'无'}}</p>
        </li>
        <li>
          <p>申办方</p>
          <p>{{evaluatelist.sponsorName?evaluatelist.sponsorName:'无'}}</p>
        </li>
        <li>
          <p>公司名称</p>
          <p>{{evaluatelist.smoName?evaluatelist.smoName:'无'}}</p>
        </li>
        <!-- <li>
          <p>公司区域</p>
          <p>{{evaluatelist.smoProvince?evaluatelist.smoProvince:'无'}}</p>
        </li>-->
      </ul>
      <p class="remarks">{{evaluatelist.projectDesc?evaluatelist.projectDesc:'无'}}</p>
    </div>
    <!-- 人员列表 -->
    <div class="continer-title base-content">
      <div class="blue">CRC人员列表</div>
      <p class="right" style="margin-top:-20px;">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
      </p>
    </div>
    <!-- 全部评价模块----当点击全选或者多选时全部评价模块出现 -->
    <div class="base-content whole-appraise" v-show="wholestatus">
      <p>
        <span class="whole-title">CRC人员</span>
        <span class="blue" v-for="items in changename" :key="items.index">{{items}}</span>
      </p>
      <p>
        <span class="whole-title">星级</span>
        <span>
          <i
            class="el-icon-star-on"
            @click="clickfun(index+1)"
            v-for="(item,index) in 5"
            :key="index"
            :class="index+1<=starlength?'ling':''"
          ></i>
        </span>
        <span>{{starDesc}}</span>
      </p>
      <p>
        <span class="whole-title left">评语</span>
        <el-input type="textarea" :rows="2" placeholder="请填写您宝贵的评语！" v-model="comment"></el-input>
      </p>
      <div class="center">
        <el-button type="info" @click="wholestatus=false">取消</el-button>
        <el-button type="primary" @click="qbpj">提交</el-button>
      </div>
    </div>

    <!-- 单个评价模块 -->
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <div class="base-content person-list" v-for="(item,index) in personlist" :key="item.id">
        <ul class="list-msg">
          <li>
            <el-checkbox
              :label="item.projectExpId+'*'+item.name"
              :disabled="item.isComment==1?true:false"
              @change="change"
            >&nbsp;</el-checkbox>
          </li>
          <li class="img-src">
            <img :src="imgurl+item.headImg" />
          </li>
          <li>
            <div class="person-list-title">
              <div class="person-name">{{item.name}}</div>
              <div class="goodAts">
                <span v-for="items in item.goodAts" :key="items.index">{{items}}</span>
              </div>
            </div>

            <ul>
              <li>
                <p>项目数量</p>
                <p>{{item.projectNum?item.projectNum:'0'}}</p>
              </li>
              <li>
                <p>学校</p>
                <p>{{item.schoolName?item.schoolName:'无'}}</p>
              </li>
              <li>
                <p>学历</p>
                <p>{{item.eduLevel?item.eduLevel:'无'}}</p>
              </li>
              <li>
                <p>专业</p>
                <p>{{item.major?item.major:'无'}}</p>
              </li>
              <li>
                <p>备案时间</p>
                <p>{{item.beianTime?item.beianTime:'无'}}</p>
              </li>
            </ul>
          </li>
          <li class="msg-modal blue">
            <a @click="previewMsg(item.id)">查看资料</a>
          </li>
        </ul>
        <!-- 没有评价的情况下显示的 -->
        <div style="margin-left:40px;" class="person-appraise" v-if="item.isComment==0">
          <p>
            <span class="whole-title">星级</span>
            <span>
              <i
                class="el-icon-star-on"
                @click="starclick(index,sum+1)"
                v-for="(items,sum) in 5"
                :key="sum"
                :class="sum+1<=item.starNum?'ling':''"
              ></i>
            </span>
            <span ref="starDesc" class="dsf"></span>
          </p>
          <p>
            <span class="whole-title left">评语</span>
            <el-select
              v-model="searchvalue"
              filterable
              @change="changeappraise"
              style="width:750px;"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.value"
                :value="item.value"
                :reserve-keyword="true"
                ref="appraiseItem"
              ></el-option>
            </el-select>
            <a class="btn right" @click="pj(index,item.projectExpId,item.starNum)">提交评价</a>
            <textarea
              placeholder="请输入评价"
              style="width: 820px;display:block;"
              ref="appraiseItem2"
              v-if="searchvaluestatus"
            ></textarea>
          </p>
        </div>
        <!-- 有评价的情况下显示的 -->
        <div style="margin-left:40px;" class="person-appraise" v-if="item.isComment==1">
          <p>
            <span class="whole-title">星级</span>
            <span>
              <i
                class="el-icon-star-on"
                v-for="(items,sum) in 5"
                :class="sum+1<=item.starNum?'ling':''"
                :key="sum"
              ></i>
            </span>
            <span ref="starDesc">{{item.starDesc}}</span>
          </p>
          <div>
            <span class="whole-title left">评语</span>
            <div style="font-size:15px;" ref="appraiseItem">{{item.comment}}</div>
          </div>
        </div>
      </div>
    </el-checkbox-group>
    <!-- 查看资料-->
    <div class="preview-modal" v-if="peviewstatus">
      <Preview @peviewstatus="closePeview" :childid="childid"></Preview>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { evaluate } from "@/request/api";
import { pj } from "@/request/api";
import Preview from "../components/preview";
export default {
  components: {
    Preview: Preview
  },
  data() {
    return {
      childid: "",
      peviewstatus: false,
      projectid: "",
      evaluatelist: [],
      personlist: [],
      minheight: this.Common.minheight,
      comment: "",
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: false,
      checkedGameId: [],
      wholestatus: false, //全部评价模块
      starlength: "",
      starDesc: "", //全部评价星级备注
      comment: "", //全部评价评语
      imgurl: this.Common.imgurl,
      changejsons: [],
      changeid: [],
      changename: [],
      options: [
        {
          value: "非常优秀",
          label: "1"
        },
        {
          value: "良好",
          label: "2"
        },
        {
          value: "一般",
          label: "3"
        },
        {
          value: "差",
          label: "4"
        },
        {
          value: "其他",
          label: "5"
        }
      ],
      searchvalue: "",
      searchvaluestatus: false
    };
  },
  methods: {
    //
    changeappraise() {
      if (this.searchvalue == "其他") {
        this.searchvaluestatus = true;
      } else {
        this.searchvaluestatus = false;
      }
    },

    // 评价人员列表
    evaluate() {
      evaluate(this.projectid)
        .then(res => {
          this.evaluatelist = res.data.data;
          console.log(this.evaluatelist);
          this.personlist = res.data.data.list;
          for (let i = 0; i < this.personlist.length; i++) {
            this.checkedGameId.push(
              this.personlist[i].projectExpId + "*" + this.personlist[i].name
            );
            // this.multipleSelection = this.checkedGameId
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 多选
    handleCheckAllChange(val) {
      // 若val为真返回cityoptions,否则返回[]
      this.checkedCities = val ? this.checkedGameId : [];
      this.isIndeterminate = false;
      if (this.checkedCities.length > 1) {
        this.wholestatus = true;
      } else {
        this.wholestatus = false;
      }
      this.change();
    },
    handleCheckedCitiesChange(value) {
      if (this.checkedCities.length > 1) {
        this.wholestatus = true;
      } else {
        this.wholestatus = false;
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkedGameId.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.checkedGameId.length;
    },
    change() {
      this.changejsons = [];
      for (let i = 0; i < this.checkedCities.length; i++) {
        this.changejsons.push(this.checkedCities[i].split("*"));
      }
      this.changeid = [];
      for (let i = 0; i < this.changejsons.length; i++) {
        this.changeid.push(this.changejsons[i][0]);
      }
      console.log(this.changeid);
      this.changename = [];
      for (let i = 0; i < this.changejsons.length; i++) {
        this.changename.push(this.changejsons[i][1]);
      }
      console.log(this.changename);
    },
    // 查看资料
    previewMsg(id) {
      this.childid = id;
      this.peviewstatus = true;
    },
    closePeview(data) {
      this.peviewstatus = data;
    },
    // 全部评价单击星级
    clickfun(index) {
      console.log(index);
      this.starlength = index;
      if (this.starlength == 1) {
        this.starDesc = "差";
      } else if (this.starlength == 2) {
        this.starDesc = "一般";
      } else if (this.starlength == 3) {
        this.starDesc = "良好";
      } else if (this.starlength == 4) {
        this.starDesc = "好";
      } else if (this.starlength == 5) {
        this.starDesc = "优秀";
      }
    },
    // 单个列表星星点击
    starclick(index, num) {
      if (num == 1) {
        this.$refs.starDesc[index].innerText = "差";
      } else if (num == 2) {
        this.$refs.starDesc[index].innerText = "一般";
      } else if (num == 3) {
        this.$refs.starDesc[index].innerText = "良好";
      } else if (num == 4) {
        this.$refs.starDesc[index].innerText = "好";
      } else if (num == 5) {
        this.$refs.starDesc[index].innerText = "优秀";
      }
      console.log(this.personlist[index]);
      this.personlist[index].starNum = num;
      // alert(this.personlist[index].starNum);
      // this.$refs.starDesc[index].add("a");
    },
    // 单个评价按钮
    pj(index, id, starNum) {
      console.log(this.$refs.appraiseItem[index].value);
      // alert(this.personlist[index].starNum)

      // 增加默认星星的数量 0 个
      if (!this.personlist[index].starNum) {
        this.personlist[index].starNum = 0;
      }
      console.log(this.searchvaluestatus);
      var comment;
      if (this.searchvaluestatus == false) {
        comment = this.$refs.appraiseItem[index].value;
      } else {
        comment = this.$refs.appraiseItem2[index].value;
      }

      let data = {
        comment: comment,
        flag: 1,
        id: this.personlist[index].projectExpId,
        starDesc: this.$refs.starDesc[index].innerText,
        starNum: this.personlist[index].starNum,
        userId: Cookies.get("userid")
      };
      console.log(data);
      pj(data)
        .then(res => {
          console.log(res.data);
          if (res.data.code == "00000") {
            this.$message({
              message: "评价成功",
              type: "success"
            });
            this.evaluate();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 全全部评价
    qbpj() {
      let expids = this.changeid.join(",");
      let data = {
        comment: this.comment,
        flag: 1,
        id: expids,
        starDesc: this.starDesc,
        starNum: this.starlength,
        userId: Cookies.get("userid")
      };
      pj(data)
        .then(res => {
          if ((res.data.code = "00000")) {
            this.$message({
              message: "评价成功",
              type: "success"
            });
            this.evaluate();
            this.wholestatus = false;
          } else {
            this.$message(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    test() {
      console.log(1);
      this.$emit("test"); //把a标签的点击事件分发
    },
    shout() {
      console.log("我触发了它");
    }
  },
  mounted() {
    this.evaluate();
  },
  created() {
    // 项目id
    this.projectid = this.$route.params.id;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.items {
  margin-top: 20px;
  margin-bottom: 20px;
}

.items .list-name {
  font-size: 18px;
  color: #4d4d4d;
}

.items li {
  display: inline-block;
  margin-right: 30px;
}

.item li:last-child {
  margin-right: 0px;
}

.list-msg li p:first-child {
  color: #999999;
  /* font-weight:bold; */
  font-size: 14px;
}

.list-msg li p:last-child {
  color: #666666;
  margin-top: 10px;
  font-size: 16px;
  /* font-weight:bold; */
}

.remarks {
  width: 100%;
  /* height: 40px; */
  line-height: 40px;
  background: rgba(245, 245, 245, 1);
  color: #999999;
  font-size: 14px;
  margin-top: 26px;
  padding-left: 5px;
}

.el-textarea {
  width: 899px;
}

.person-list {
  height: auto;
}

.ling {
  color: #f00;
}

textarea {
  font-size: 12px;
  padding-top: 5px;
  padding-left: 10px;
  border-radius: 4px;
  max-width: 750px;
  margin-left: 100px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/hospital/appraise.vue